module.exports = __webpack_public_path__ + "static/media/editImageIcon.5d9ca037.png";